import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useSceneStore = defineStore('scene', () => {
    const scenecode = ref<string>("")
    function setscenecode(scene: string) {
        scenecode.value = scene
    }
    return { scenecode, setscenecode }
})

export const modifyuserSceneStore = defineStore('store', () => {
    const scenecode = ref<string>("")    
    function setSceneStore(store: string) {
        scenecode.value = store
    }
    return { scenecode, setSceneStore }
})  

export const userSignalRStore = defineStore('userSignalR', () => {
    const connectionId = ref<string>('')
    const signalRMessage=ref<any>(null)

    function setConnectionId(id: string) {
        connectionId.value = id
    }
    function setSignalRMessage(message: any) {
        signalRMessage.value = message
    }   
    return { connectionId, signalRMessage, setConnectionId, setSignalRMessage }
})

export const loginStore = defineStore('login', () => {
    const isLogin = ref<boolean>(false)
    const avatar = ref<string>('')
    function setIsLogin(result: boolean) {
        isLogin.value = result
    }
    function setAvatar(userThumb: string) {
        avatar.value = userThumb;
    }
    return {  isLogin, avatar, setIsLogin, setAvatar }
})

